import { render, staticRenderFns } from "./vthankyoutext.vue?vue&type=template&id=3c4577c8&scoped=true&"
import script from "./vthankyoutext.vue?vue&type=script&lang=js&"
export * from "./vthankyoutext.vue?vue&type=script&lang=js&"
import style0 from "./vthankyoutext.vue?vue&type=style&index=0&id=3c4577c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4577c8",
  null
  
)

export default component.exports